module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-container', {
    staticClass: "text-xs-center"
  }, [(_vm.loading) ? _c('v-progress-circular', {
    staticClass: "mt-5",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('h2', [_vm._v("Welcome " + _vm._s(_vm.name) + ".")]), _vm._v(" "), _c('h3', [_vm._v("Role " + _vm._s(_vm.role))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/Cubo-Logo.png"
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5479bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 769
// module chunks = 1